import { render, staticRenderFns } from "./MarketItem.vue?vue&type=template&id=ceb527a4&scoped=true"
import script from "./MarketItem.vue?vue&type=script&lang=js"
export * from "./MarketItem.vue?vue&type=script&lang=js"
import style0 from "./MarketItem.vue?vue&type=style&index=0&id=ceb527a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb527a4",
  null
  
)

export default component.exports